import TextField from '@mui/material/TextField';
// import { ThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
// import { createTheme } from "@material-ui/core/styles";



const theme = createTheme({
    
  overrides: {
    
  }
});

export default function CustomTestField(props) {
  return (
    <ThemeProvider theme={theme}>
        <span style={{
                borderColor: props.borderColor?props.borderColor:'#2E5266',
                borderStyle: 'solid',
                borderRadius: '15px',
                width:'100%',
                paddingTop:'4px',
                paddingRight:'10px',
                boxShadow:'#00000033 0px 3px 6px',
                paddingLeft:'10px',
                backgroundColor:'#fff'
        }}>
        <TextField variant="standard"  
            placeholder={props.label}
            multiline={props.multiline}
            maxRows={props.multiline?4:1}
            rows={props.multiline?4:1}
            sx={{
                width:'100%'
            }}
          
            InputProps={{
                disableUnderline: true,
                    // startAdornment: (
                    //     <InputAdornment position="start">
                    //     {props.icon} 
                    //     </InputAdornment>
                    // ),
                    endAdornment:(
                        <InputAdornment position="start">
                         {props.icon}
                        </InputAdornment>
                    )
            }}
        />
        </span>
    </ThemeProvider>
  );
}
